import React from 'react';
import PropTypes from 'prop-types';


export const LayoutType = {
	Default: 'default',
	Login: 'login'
  };

const SideNav = ({ children }) => <>{children}</>;
const Header = ({ children }) => <>{children}</>;
const Footer = ({ children }) => <>{children}</>;
const Main = ({ children }) => <>{children}</>;

const BannerSection = ({ children }) => <>{children}</>;
const LoginSection = ({ children }) => <>{children}</>;

const Layout = ({ children, type = LayoutType.Default, ...rest }) => {
	const sideNav = React.Children.toArray(children).find((child) => child.type === SideNav);
	const header = React.Children.toArray(children).find((child) => child.type === Header);
	const footer = React.Children.toArray(children).find((child) => child.type === Footer);
	const main = React.Children.toArray(children).find((child) => child.type === Main);

	const bannerSection = React.Children.toArray(children).find((child) => child.type === BannerSection);
	const loginSection = React.Children.toArray(children).find((child) => child.type === LoginSection);

	if (type === LayoutType.Login) {
		return (
			<div className="DS__login-container" {...rest}>
				{bannerSection && <div className="DS__login-container__banner-section">{bannerSection}</div>}
				{loginSection && <div className="DS__login-container__login-section">{loginSection}</div>}
			</div>
		);
	}

	return (
		<div className="DS__layout-container" {...rest}>
			{sideNav && <aside className="DS__layout-left__side-nav">{sideNav}</aside>}
			<div className="DS__layout-right__content">
				{header && <header className="DS__layout-right__header">{header}</header>}
				{main && <main className="DS__layout-right__main">{main}</main>}
				{footer && <footer className="DS__layout-right__footer">{footer}</footer>}
			</div>
		</div>
	);
};

Layout.SideNav = SideNav;
Layout.Header = Header;
Layout.Footer = Footer;
Layout.Main = Main;
Layout.BannerSection = BannerSection;
Layout.LoginSection = LoginSection;


Layout.propTypes = {
	children: PropTypes.node.isRequired,
	type: PropTypes.oneOf([LayoutType.Default, LayoutType.Login]),
};

SideNav.propTypes = {
	children: PropTypes.node,
};

Header.propTypes = {
	children: PropTypes.node,
};

Footer.propTypes = {
	children: PropTypes.node,
};

Main.propTypes = {
	children: PropTypes.node,
};

BannerSection.propTypes = {
	children: PropTypes.node,
};

LoginSection.propTypes = {
	children: PropTypes.node,
};
export default Layout;
